import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import Streak from '../../../../../components/Images/Streak'
import BlueClock from '../../../../../components/Images/BlueClock'

const StreakIcon = styled(Streak)`
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  right: 0;
`
const ClockIcon = styled(BlueClock)`
  position: absolute;
  top: 0;
  left: 0;
`
const StreakDayTxt = styled.div`
  margin-top: 5px;
  font-weight: 500;
  color: rgba(13, 21, 54, 0.4);
`

const DateCell = styled.li`
  height: ${({ height }) => height || '40px'};
  grid-column-start: unset;
  background-color: ${({ bg }) => bg};
  position: relative;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin-right: ${({ marginR }) => marginR || '4px'};
`

const DateText = styled.span`
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  color: ${({ color }) => color};
  cursor: pointer;
`

const IncentiveAmount = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33;
  color: ${({ color }) => color};
`

const CalenderBox = styled.div`
  max-width: 600px;
  margin: 0 auto;
`
export default function WeekCalender({ incentives_data, wbpFirstOngoingDate, isUgcBook }) {

  const lastIncentiveDate = Object.keys(incentives_data || {}).at(-1) // This will pick the last streak Date, coming at the last position of incentive Object
  const startOfWeek = moment(lastIncentiveDate, "DD-MM-YYYY").startOf('isoWeek')
  const endOfWeek = moment(lastIncentiveDate, "DD-MM-YYYY").endOf('isoWeek')
  const activeWeekDays = []
  const activeYear = []
  const activeYear2 = []
  let day = startOfWeek
  const list = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  while (day <= endOfWeek) {
    activeWeekDays.push(day.format('DD'))
    activeYear.push(day.format('DD/MM/YYYY'))
    activeYear2.push(day.format('YYYY/MM/DD'))
    day = day.clone().add(1, 'd')
  }
  const firstOngoingDate = new Date(wbpFirstOngoingDate)
  const isMobile = window.screen.width <= 600
  let streakDays = 0
  for (const date in incentives_data) {
    const dateComparison1 = new Date(date)
    const dateComparison2 = new Date(activeYear[0])
    if (
      incentives_data[date]?.streak_day === true &&
      dateComparison1.getTime() < dateComparison2.getTime()
    ) {
      streakDays++
    } else if (incentives_data[date]?.streak_day !== true) {
      streakDays = 0
    }
    if (dateComparison1.getTime() === dateComparison2.getTime()) break
  }
  if (!incentives_data) {
    return <div />
  }

  return (
    <CalenderBox>
      <ol className="calendar" id="day-list">
        {list.map((data) => (
          <li key={data} className="day-name">
            {data}
          </li>
        ))}
        {activeWeekDays.map((day, index) => {
          const curDayMonthYear = activeYear[index]
          const curYearMonthDay = activeYear2[index]
          const isApprovedMonthAndYear =
            firstOngoingDate.getMonth() ===
              new Date(curYearMonthDay).getMonth() &&
            firstOngoingDate.getFullYear() ===
              new Date(curYearMonthDay).getFullYear()
          const currentDay = day === moment().format('DD') ? 'today' : ''
          const showIncentiveAmount =
            currentDay && incentives_data[curDayMonthYear]?.future_date
              ? false
              : !!incentives_data[curDayMonthYear]?.incentive_type
          const beforeApprovedDate =
            isApprovedMonthAndYear && Number(day) < firstOngoingDate.getDate()
          incentives_data[curDayMonthYear]?.streak_day === true
            ? streakDays++
            : (streakDays = 0)
          return (
            <div>
              <DateCell
                key={day}
                bg={
                  incentives_data[curDayMonthYear]?.incentive_type ===
                  'full_incentive'
                    ? '#c3ea69'
                    : incentives_data[curDayMonthYear]?.incentive_type ===
                      'streak_incentive'
                    ? '#799e22'
                    : incentives_data[curDayMonthYear]?.incentive_type ===
                      'half_incentive'
                    ? '#fbe565'
                    : incentives_data[curDayMonthYear]?.incentive_type ===
                      'missed_day'
                    ? '#f7737b'
                    : '#ffffff'
                }
                marginR={isMobile ? '1px' : '4px'}
                height={'58px'}
              >
                {incentives_data[curDayMonthYear]?.streak_day && <StreakIcon />}
                {incentives_data[curDayMonthYear]?.future_date && <ClockIcon />}
                <DateText
                  color={
                    beforeApprovedDate
                      ? 'rgba(13, 21, 54, 0.3)'
                      : currentDay
                      ? '#068ae2'
                      : incentives_data[curDayMonthYear]?.incentive_type ===
                        'missed_day'
                      ? '#9f111a'
                      : incentives_data[curDayMonthYear]
                      ? '#295e48'
                      : 'rgba(13, 21, 54, 0.65)'
                  }
                >
                  {day}
                  <br />
                  {showIncentiveAmount &&
                    !isMobile &&
                    incentives_data[curDayMonthYear] && (
                      <IncentiveAmount
                        color={
                          incentives_data[curDayMonthYear]?.incentive_type ===
                            'full_incentive' ||
                          incentives_data[curDayMonthYear]?.incentive_type ===
                            'streak_incentive'
                            ? '#54b585'
                            : incentives_data[curDayMonthYear]
                                ?.incentive_type === 'missed_day'
                            ? '#dd3623'
                            : '#b9990b'
                        }
                      >
                        {isUgcBook ? '$' : '₹'}{incentives_data[curDayMonthYear]?.incentive}
                      </IncentiveAmount>
                    )}
                  {showIncentiveAmount &&
                    isMobile &&
                    incentives_data[curDayMonthYear] && (
                      <IncentiveAmount
                        color={
                          incentives_data[curDayMonthYear]?.incentive_type ===
                            'full_incentive' ||
                          incentives_data[curDayMonthYear]?.incentive_type ===
                            'streak_incentive'
                            ? '#54b585'
                            : incentives_data[curDayMonthYear]
                                ?.incentive_type === 'missed_day'
                            ? '#dd3623'
                            : '#b9990b'
                        }
                      >
                        {isUgcBook ? '$' : '₹'}{incentives_data[curDayMonthYear]?.incentive}
                      </IncentiveAmount>
                    )}
                </DateText>
              </DateCell>
              {streakDays > 0 && <StreakDayTxt>Day {streakDays}</StreakDayTxt>}
            </div>
          )
        })}
      </ol>
    </CalenderBox>
  )
}
